import { Construction } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Pantalla para los módulos que todavía no están construidos.
 *
 * Es **honesta a propósito**: dice exactamente qué va a hacer esa sección cuando
 * esté lista, en lugar de mostrar una pantalla vacía o, peor, datos inventados.
 */
export function ComingSoonPage({
  title,
  detail,
}: {
  title: string;
  detail: string;
}): React.JSX.Element {
  return (
    <div className="animate-ed-fade-in space-y-4">
      <header className="flex items-start gap-3">
        <Construction className="mt-1 shrink-0 text-ed-gold" size={22} aria-hidden="true" />
        <div>
          <h1 className="font-display text-xl font-extrabold tracking-tight">{title}</h1>
          <p className="text-sm text-ed-text-muted">Todavía en construcción</p>
        </div>
      </header>

      <section className="ed-card p-4">
        <h2 className="mb-2 text-sm font-bold uppercase tracking-wider text-ed-text-silver">
          Qué hará esta sección
        </h2>
        <p className="text-sm leading-relaxed text-ed-text-silver">{detail}</p>
      </section>

      <Link to="/" className="ed-btn-secondary w-full">
        Volver al inicio
      </Link>
    </div>
  );
}
